var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66101 6.19181L5.23508 15.6052C5.2796 16.3254 5.88915 16.9047 6.64953 16.9047H13.0392C13.7834 16.9047 14.3868 16.3493 14.4521 15.6469L15.3172 6.19041C13.7344 6.08918 11.625 5.97806 10 5.97806C8.36754 5.97806 6.24622 6.09021 4.66101 6.19181ZM16.7428 6.28791C16.8969 6.29914 17.0327 6.30927 17.1471 6.31793C17.2795 6.32796 17.3833 6.33603 17.4539 6.34158L17.5609 6.35009C17.9541 6.38202 18.299 6.08919 18.331 5.69599C18.3629 5.3028 18.07 4.95816 17.6769 4.92623L17.5659 4.91741C17.494 4.91175 17.3888 4.90358 17.2549 4.89344C16.9872 4.87316 16.6045 4.84501 16.144 4.81348C14.5327 4.70312 11.9438 4.54949 10 4.54949C8.05619 4.54949 5.46733 4.70312 3.856 4.81348C3.39555 4.84501 3.01286 4.87316 2.74509 4.89344C2.6112 4.90358 2.506 4.91175 2.43414 4.91741L2.32374 4.92619C1.93054 4.95812 1.63713 5.3028 1.66906 5.69599C1.701 6.08918 2.04562 6.38205 2.43881 6.35012M2.43881 6.35012L2.54615 6.34158C2.61673 6.33603 2.72054 6.32796 2.85297 6.31793C2.96204 6.30967 3.0905 6.30008 3.23575 6.28948L3.80919 15.6927C3.90126 17.1857 5.15383 18.3333 6.64953 18.3333H13.0392C14.5015 18.3333 15.7398 17.2352 15.8746 15.778L16.7428 6.28791",
    fill: "#F45F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66669 3.0952C8.53519 3.0952 8.4286 3.2018 8.4286 3.33329V4.85196C8.4286 5.24645 8.1088 5.56625 7.71431 5.56625C7.31983 5.56625 7.00003 5.24645 7.00003 4.85196V3.33329C7.00003 2.41282 7.74622 1.66663 8.66669 1.66663H11.3333C12.2538 1.66663 13 2.41282 13 3.3333V4.85196C13 5.24645 12.6802 5.56625 12.2857 5.56625C11.8912 5.56625 11.5714 5.24645 11.5714 4.85196V3.3333C11.5714 3.2018 11.4648 3.0952 11.3333 3.0952H8.66669Z",
    fill: "#F45F5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23818 4.85198C6.23818 4.45749 6.55797 4.13769 6.95246 4.13769L8.47626 4.13769C8.87075 4.13769 9.19055 4.45749 9.19055 4.85198C9.19055 5.24647 8.87075 5.56626 8.47626 5.56626H6.95246C6.55797 5.56626 6.23818 5.24647 6.23818 4.85198Z",
    fill: "#F45F5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8095 4.85198C10.8095 4.45749 11.1293 4.13769 11.5238 4.13769H13.0476C13.4421 4.13769 13.7619 4.45749 13.7619 4.85198C13.7619 5.24647 13.4421 5.56626 13.0476 5.56626H11.5238C11.1293 5.56626 10.8095 5.24647 10.8095 4.85198Z",
    fill: "#F45F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.25611C10.3945 8.25611 10.7143 8.57591 10.7143 8.9704V13.9125C10.7143 14.307 10.3945 14.6268 10 14.6268C9.60553 14.6268 9.28574 14.307 9.28574 13.9125V8.9704C9.28574 8.57591 9.60553 8.25611 10 8.25611Z",
    fill: "#F45F5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95246 9.07976C7.34695 9.07976 7.66674 9.39956 7.66674 9.79405V13.0888C7.66674 13.4833 7.34695 13.8031 6.95246 13.8031C6.55797 13.8031 6.23818 13.4833 6.23818 13.0888V9.79405C6.23818 9.39956 6.55797 9.07976 6.95246 9.07976Z",
    fill: "#F45F5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0476 9.07976C13.4421 9.07976 13.7619 9.39956 13.7619 9.79405V13.0888C13.7619 13.4833 13.4421 13.8031 13.0476 13.8031C12.6531 13.8031 12.3333 13.4833 12.3333 13.0888V9.79405C12.3333 9.39956 12.6531 9.07976 13.0476 9.07976Z",
    fill: "#F45F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.f8158a14.svg";
export { ForwardRef as ReactComponent };